<template>
  <div class="page">
    <div class="top">
      <img :src="params.avatarUrl" mode="" />
    </div>
    <div class="ul">
      <div class="li lis">
        <div>姓名</div>
        <div>{{ params.name }}</div>
      </div>
      <div class="li">
        <div>岗位</div>
        <div>{{ params.assessor }}</div>
      </div>
      <div class="li">
        <div>岗位级别</div>
        <div>{{ params.levelDesc }}</div>
      </div>
      <div class="li">
        <div>证书编号</div>
        <div>{{ params.certificateNo }}</div>
      </div>
    </div>
    <div class="ul">
      <div class="li lis">
        <div>发证单位</div>
        <div>{{ params.certificateUnit }}</div>
      </div>
      <div class="li">
        <div>发证时间</div>
        <div>{{ params.time }}</div>
      </div>
      <div class="li">
        <div>证书下载</div>
        <div class="lbox" @click="downloadAndSave">
          <div>下载</div>
          <img
            src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation/certificate_query_3.png"
            mode=""
          />
        </div>
      </div>
    </div>
    <div class="tips">
      <div class="t1">使用说明</div>
      <div class="t2">1.本证为证明中国汽车流通行业人员的岗位水平所用。</div>
      <div class="t2">2.请妥善保管本证，请勿折损。</div>
      <div class="t2">
        3.本证应按照要求定期年检，相关要求以协会官方通知为准。
      </div>
      <div class="t2">
        4.请遵守中国汽车流通行业信用规则，本证不得转借给他人使用。
      </div>
      <div class="t2">5.由中国汽车流通协会负责本证使用规则的解释。</div>
      <div class="tl">
        <div class="t2">中国汽车流通协会官方网站</div>
        <div class="t2">www.cada.cn</div>
      </div>
    </div>
  </div>
</template>
<!-- getCertByNum -->
<script>
import { getCertByNum } from "@/utils/http.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      params: {
        avatarUrl: "",
        name: "",
        assessor: "",
        levelDesc: "",
        certificateNo: "",
        certificateUnit: "",
        createdTime: "",
      },
    };
  },
  created() {
    this.getCertByNums();
  },
  mouted() {
    this.getCertByNums();
  },
  methods: {
    getCertByNums() {
      getCertByNum({ number: this.$route.query.number }).then((res) => {
        console.log(res);
        if (res.data.resultStates != 0) {
          Toast(res.data.message);
          return;
        }
        res.data.content.time = this.timestampToDate(res.data.content.certDate);
        this.params = res.data.content;
      });
    },
    downloadAndSave() {
      const link = document.createElement("a");
      link.href = this.params.certUrl;
      var a = document.createElement("a");
      a.href = this.params.certUrl;
      a.target = "_blank";
      a.click();
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以需要+1
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style scoped>
.page {
  height: 100vh;
  background: #f8f8f8;
}

.top {
  width: 375px;
  height: 170px;
  background: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top img {
  width: 100px;
  height: 140px;
}

.ul {
  box-sizing: border-box;
  padding: 0 15px;
  margin: 10px 0;
  background: #ffffff;
}

.li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 90px; */
  padding: 12px 0;
  border-top: 1px solid #ebebeb;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #333330;
}

.lis {
  border: none;
}

.li > div:nth-of-type(1) {
  color: #333333;
}

.lbox {
  display: flex;
  align-items: center;
}

.lbox img {
  width: 14px;
  height: 14px;
  margin-left: 6px;
}

.tips {
  box-sizing: border-box;
  padding: 14px 15px;
  background: #ffffff;
}

.t1 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  margin-bottom: 7px;
}

.t2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.tl {
  box-sizing: border-box;
  padding-left: 165px;
  margin-top: 22px;
}
</style>
